
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/puppies-for-sale",
      function () {
        return require("private-next-pages/puppies-for-sale/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/puppies-for-sale"])
      });
    }
  